module.exports = __webpack_public_path__ + "static/rcc-pfs-graph-mobile-ccdc448c759a5e9b401eff5d5f67eed6.png";